import { useQuery } from '@tanstack/react-query';
import type { SearchResponse } from '@accounting/shared';
import { api } from '../lib/api';

export function useSearch(companyId: string | null, q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: ['search', companyId ?? 'none', term],
    enabled: companyId !== null && term.length > 0,
    queryFn: () =>
      api.get<SearchResponse>(`/companies/${companyId}/search`, { q: term }),
  });
}
